import { ActionIcon, Text } from '@mantine/core';
import { IconSquareArrowRight } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ActivitiesMutationResourceSchema,
    defaultActivitiesResource,
    useActivitiesActions,
} from '../../../../../resource/resources/artifacts/activities/activitiesResource';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { useMyNavigate } from '../../../../router/createdRouter';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ActivityContent } from './ActivityContent';

export const ActivityView = ({
    id,
    projectId,
    projectVersionId,
}: {
    id: string | undefined;
    projectId: string | undefined;
    projectVersionId: string | undefined;
}) => {
    const navigate = useMyNavigate();
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const activitiesActions = useActivitiesActions();
    const activitiesQuery = activitiesActions.useGetResource(id);
    const updateActivities = activitiesActions.useUpdateResource();
    const validateActivities = activitiesActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ActivitiesMutationResourceSchema,
        defaultValues: defaultActivitiesResource,
        submitHandler: async (data) => {
            await updateActivities.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: activitiesQuery.data,
    });

    return (
        <QueryBaseComponent name="Activities" query={activitiesQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateActivities.data}
                    metaDataInfo={activitiesQuery.data}
                    resourceType={ResourceType.ACTIVITIES}
                    customButtons={
                        <ActionIcon
                            variant={'transparent'}
                            size={'small'}
                            onClick={() => {
                                if (projectId && projectVersionId && id) {
                                    navigate({
                                        route: '/project/:id/active-version/:versionId/activities-model/:activitiesId',
                                        routeParams: {
                                            id: projectId,
                                            versionId: projectVersionId,
                                            activitiesId: id,
                                        },
                                    });
                                }
                            }}
                            style={{ padding: '2px' }}
                            color={'var(--mantine-color-base-button)'}
                        >
                            <IconSquareArrowRight />
                        </ActionIcon>
                    }
                >
                    <Text c="dimmed">Activity</Text>
                </ResourceValidationTitleBar>
                <ActivityContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
